import logoUrl from '../assets/tsunami.svg';

export function BrandMark({ className = 'size-8' }: { className?: string }) {
  return (
    <span className={`inline-flex shrink-0 items-center justify-center rounded-md bg-ink-950 ring-1 ring-brand-300/30 shadow-lg shadow-brand-900/30 ${className}`}>
      {/* No inset padding — the artwork already carries its own margin, so
          padding here just shrinks it inside the tile. */}
      <img src={logoUrl} alt="" className="h-full w-full object-contain" />
    </span>
  );
}
